module.exports = __webpack_public_path__ + "img/orange.349b3094.svg";